const KEY_PREFIX = 'arca_transfer_confirmed_seen_';

/**
 * "Se descarta y no vuelve": la confirmación puntual de un traspaso completado
 * se ve una sola vez, en la primera visita tras el evento. No hay backend que
 * lo recuerde (el aviso persistente es el email transaccional), así que se
 * marca en local. Si `localStorage` falla (modo privado, cuota…) se trata como
 * "ya vista" — es más seguro no repetir un aviso de más que arriesgarse a que
 * no desaparezca nunca.
 */
/**
 * 🔴 `siNoSePuedeLeer` lo decide quien llama, y no es un detalle: los dos consumidores quieren
 * lo contrario cuando `localStorage` no está disponible (ventana privada, datos de sitio
 * bloqueados — Chrome lanza `SecurityError` en el propio acceso).
 *
 * - `TarjetaTraspaso` (components/Traspasos) pide `true`: lo que se suprime es un aviso puntual, y repetirlo para
 *   siempre es peor que perdérselo una vez.
 * - El dashboard pide `false`: aquí no se suprime un aviso, se BORRA la tarjeta de proceso de la
 *   única pantalla donde se sigue el traspaso. Fallar hacia «ya visto» dejaría a esa persona sin
 *   ver su traspaso desde la primera visita, y podría llevarla al estado vacío de «no has
 *   traspasado ningún plan». Ante la duda, enseñarlo.
 */
export function hasSeenTransferConfirmation(transferId: string, siNoSePuedeLeer = true): boolean {
	try {
		return localStorage.getItem(KEY_PREFIX + transferId) === '1';
	} catch {
		return siNoSePuedeLeer;
	}
}

export function markTransferConfirmationSeen(transferId: string): void {
	try {
		localStorage.setItem(KEY_PREFIX + transferId, '1');
	} catch {
		// noop: sin persistencia no hay nada que recordar. Qué pasa entonces al LEER lo decide
		// cada consumidor con `siNoSePuedeLeer`, arriba.
	}
}
